var reportSold = "https://shopfront-cdn.tekoapis.com/static/19a896d6b4db97b8.svg";

export { reportSold as default };
